import { ensureFreshAccessToken } from '../services/api';
import { getStoredAuth } from './onboardingSaveStorage';
import {
  clearPendingOnboardingSave,
  getPendingOnboardingSave,
  startPendingOnboardingSaveRetry,
} from './onboardingPendingSave';

let stopRetry = null;

/** Server confirmed setup is done: remember it locally and drop any pending save. */
export function markOnboardingConfirmed() {
  localStorage.setItem('maestro_onboarding_complete', 'true');
  clearPendingOnboardingSave();
  stopRetry?.();
  stopRetry = null;
}

/**
 * Setup was finished but its save hasn't reached the server yet: keep the user in
 * the app and retry the save in the background — never back to the start (#11472).
 * Returns false when there is no pending save (the normal redirect applies).
 */
export function keepPendingOnboardingSaveGoing() {
  const userId = getStoredAuth()?.user?.id ?? null;
  if (!getPendingOnboardingSave(userId)) return false;
  localStorage.setItem('maestro_onboarding_complete', 'true');
  if (!stopRetry) {
    stopRetry = startPendingOnboardingSaveRetry(userId, {
      getAccessToken: () => getStoredAuth()?.accessToken,
      refreshAccessToken: ensureFreshAccessToken,
    });
  }
  return true;
}
